import stJohns from './cities/stJohns'

export default {
  'province': 'Newfoundland and Labrador',
  'abbr': 'N.L.',
  'alpha': 'NL',
  'lawSociety': '',
  'writeup': '',
  'cities': [
    stJohns
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/newfoundlandLabrador/index.js